<nav aria-label="breadcrumb">
    <ol class="matero-breadcrumb">
        <li class="matero-breadcrumb-item" *ngFor="let navlink of nav; trackBy: trackByNavlink; first as isFirst;">
            <ng-container *ngIf="navlink !== ''">
                <mat-icon class="chevron" *ngIf="!isFirst">chevron_right</mat-icon>
                <span class="link">{{navlink | translate}}</span>
            </ng-container>
        </li>
    </ol>
</nav>
